import { render, staticRenderFns } from "./TemplateNoMenu.vue?vue&type=template&id=3924a7d5&scoped=true&"
import script from "./TemplateNoMenu.vue?vue&type=script&lang=ts&"
export * from "./TemplateNoMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateNoMenu.vue?vue&type=style&index=0&id=3924a7d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924a7d5",
  null
  
)

export default component.exports